import { useQuery, useQueryClient } from "@tanstack/react-query";
import { AppConfiguration } from "@/types/application";
import { toast } from "sonner";

// Coming Soon — no backend API available for app configurations yet
export const useAppConfigurations = (applicationId?: string) => {
  const queryClient = useQueryClient();

  const { data: configurations, isLoading } = useQuery({
    queryKey: ['app-configurations', applicationId],
    queryFn: async (): Promise<AppConfiguration[]> => [],
    enabled: !!applicationId
  });

  const createConfiguration = async (_config: Omit<AppConfiguration, 'id' | 'createdAt' | 'updatedAt'>) => {
    toast.info('App configuration management coming soon');
    return null;
  };

  const updateConfiguration = async (_id: string, _config: Partial<AppConfiguration>) => {
    toast.info('App configuration management coming soon');
    return null;
  };

  const deleteConfiguration = async (_id: string) => {
    toast.info('App configuration management coming soon');
  };

  const toggleConfiguration = async (_id: string, _isActive: boolean) => {
    toast.info('App configuration management coming soon');
  };

  return { configurations: configurations || [], isLoading, createConfiguration, updateConfiguration, deleteConfiguration, toggleConfiguration };
};
